// extracted by mini-css-extract-plugin
export default {"less":"page-switcher_less__saQPW","greater":"page-switcher_greater__i7hj9","selected":"page-switcher_selected__PIJJp"};